import axios from "axios";
import exp from "constants";
export type CategoryTree = {
    ID: number,
    ParentID: number | null,
    Name: string,
    Description: string,
    Tags: string // Comma seperatet
    CategoryTreeLanguage?: CategoryTree[]
}

export function addCategoryItem(mockedData: CategoryTree[], CategoryItem: CategoryTree) {
    mockedData.push(CategoryItem)
    return mockedData
}

export async function getCategoryTree(): Promise<CategoryTree[]> {
    return new Promise((resolve, reject) => {
        axios.get('categories').then(res => {
            resolve(res.data)
        }).catch(err => reject(err))
    })
}


export async function deleteCategory(categoryId: number): Promise<void> {
    return new Promise((resolve, reject) => {
        axios.delete(`categories/${categoryId}`).then(res => {
            resolve(res.data)
        }).catch(err => reject(err))
    })
}

export async function updateCategory(categoryData: CategoryTree, id: number, language: { [key: string]: CategoryTree }): Promise<CategoryTree> {
    return new Promise((resolve, reject) => {
        axios.patch(`categories/${id}`, {categoryData, language}).then((res) => {
            resolve(res.data)
        }).catch((err) => reject(err));
    })
}


export async function createCategory(categoryData: CategoryTree, language: {[key: string]: CategoryTree}): Promise<CategoryTree> {
    return new Promise((resolve, reject) => {
        axios.post('categories', {categoryData, language}).then((res) => {
            resolve(res.data)
        }).catch((err) => reject(err));
    })
}

export function buildCategoryItem(name: string, description: string, parentID: number | null, tags: string[], mockedData?: CategoryTree[]): CategoryTree {


    return {
        Description: description,
        Name: name,
        ParentID: parentID,
        Tags: tags.join(','),
        ID: getRandomAndUniqueID()
    }

    function getRandomAndUniqueID(): number {
        let ID = Math.floor(Math.random() * 100)
        if (mockedData?.map(ele => ele.ID).includes(ID)) {
            return getRandomAndUniqueID()
        } else {
            return ID
        }

    }
}

